module.exports = __webpack_public_path__ + "img/hotspotCrop-256--tiny.e268bf73.png";